export default __webpack_public_path__ + "media/zurb/img/lab/playground/playground-thumb-03a87f80a6ebdd122a647994fff7435c.png";